(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/*
    This file contains general functions that are used for various sections of plugin
 */

/*
    Pops up a boot modal warning

    message: (string), the message we want to show on the modal
 */
window.qipModalWarning = function () {
  var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var modal_html = "\n                <div class=\"modal\" tabindex=\"-1\" role=\"dialog\" id=\"warning-modal-comment\">\n                  <div class=\"modal-dialog modal-dialog-centered\" role=\"document\">\n                    <div class=\"modal-content\">\n                      <div class=\"modal-header\">\n                        <h5 class=\"modal-title\"><i class=\"fas fa-exclamation-triangle mr-2\" style=\"color:#ecb811\"></i>Warning</h5>\n                        <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Close\">\n                          <span aria-hidden=\"true\">&times;</span>\n                        </button>\n                      </div>\n                      <div class=\"modal-body\">\n                        <p style=\"font-size:14px;\">".concat(message, "</p>\n                      </div>\n                      <div class=\"modal-footer\">\n                        <button type=\"button\" class=\"btn btn-primary\" data-dismiss=\"modal\">Close</button>\n                      </div>\n                    </div>\n                  </div>\n                </div>\n        ");
  //if a modal already exists from a previous error message then remove it first
  jQuery('#warning-modal-comment').remove();

  //create and display new modal
  jQuery("body").append(modal_html);
  jQuery('#warning-modal-comment').on('shown.bs.modal', function () {
    jQuery("body.modal-open").removeAttr("style");
  });
  jQuery('#warning-modal-comment').modal();
};

/*
    Check if user is verified - if false, then do an ajax check to double check that the user hasnt verified
    their account in a differnt window. Run the callback function with either "true" or "false" as a parameter


    callbackFunction: (function), action to run when function is completed

    returns: (bool), true if user is verified and false if not
 */
window.qip_check_is_user_verified = function () {
  var callbackFunction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  /*
      If we dont have the js variable that the user has been verified (either set by wp_localize or js) then do
      ajax query to double check that user has been verified
   */
  if (window.is_user_verified === false) {
    // console.log('user verigied is false - run ajax query');
    window.ajaxQueryIsUserVerified(callbackFunction);
  }
  //if user has aleady been verified then return true and run callback function
  else {
    // console.log('user has been verified!');
    callbackFunction(true);
    return true;
  }
};

/*
    Ajax query to check in database if user is verified

    callbackFunction: (function), action to run once we confirm if user is verified or not
 */
window.ajaxQueryIsUserVerified = function (callbackFunction) {
  var _self = this;
  var params = new FormData();
  params.append('action', 'mts_is_current_user_email_verified');
  params.append('logged_in_nonce', logged_in_nonce);

  //do ajax query to get status of user verification
  fetch(_self.ajaxurl, {
    method: 'POST',
    body: params
  }).then(function (res) {
    return res.json();
  })["catch"](function (error) {
    if (window.debugMTS === "1") {
      console.log('error with submission - ', error);
    }
  }).then(function (response) {
    /*
        No reponse
     */
    if (response === 0) {
      /*
          Check if user is logged in and if not then launch a warning
       */
      window.qipModalWarning('Unknown error verifying user email.');
    }

    /*
        If user email was verified set global is_user_verified to true, otherwise set to false
     */
    if (response.verified === "1" || response.verified === 1) {
      window.is_user_verified = true;
    } else {
      //if user email  was not verified return false
      window.is_user_verified = false;
    }

    /*
        Now that we've done the verification run the callback function
     */
    callbackFunction(window.is_user_verified);
  });
};

/*
    Check if user is logged into wordpress by checking if the 'logged-in' class is set in the body tag

    returns: (bool), true if logged in and false if not logged in
 */
window.qip_is_user_logged_in = function () {
  return document.body.classList.contains('logged-in');
};

/*
    If user is not logged in, then launch a modal telling user they must log in to be able to vote

    message: (string), the warning message we want to appear when showing login message on top
 */
window.launchMustBeLoggedIn = function () {
  var top_message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  //open the modal login from the themes function
  if (window.debugMTS === "1") {
    console.log('you must be logged in!', top_message);
  }
  window.openModalLogin(top_message);
};

/*
    Pops up a boot modal warning but looks positive

    message: (string), the message we want to show on the modal
 */
window.qipModalPositiveMessage = function () {
  var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var modal_html = "\n                <div class=\"modal\" tabindex=\"-1\" role=\"dialog\" id=\"warning-modal-comment\">\n                  <div class=\"modal-dialog modal-dialog-centered\" role=\"document\">\n                    <div class=\"modal-content\">\n                      <div class=\"modal-header\">\n                        <h5 class=\"modal-title\">\n                        <img src=\"/wp-content/plugins/qip/assets/images/metaspoon_logo_square.png\" style=\"width:40px;height:40px;margin-right:10px;\">\n                        Woohoo, <span style=\"color:green;\">CONGRATULATIONS</span>!\n                        </h5>\n                        <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Close\">\n                          <span aria-hidden=\"true\">&times;</span>\n                        </button>\n                      </div>\n                      <div class=\"modal-body\">\n                        <p style=\"font-size:14px;line-height: normal;\">".concat(message, "</p>\n                      </div>\n                      <div class=\"modal-footer\">\n                        <button type=\"button\" class=\"btn btn-primary\" data-dismiss=\"modal\">Close</button>\n                      </div>\n                    </div>\n                  </div>\n                </div>\n        ");
  //if a modal already exists from a previous error message then remove it first
  jQuery('#warning-modal-comment').remove();

  //create and display new modal
  jQuery("body").append(modal_html);
  jQuery('#warning-modal-comment').on('shown.bs.modal', function () {
    jQuery("body.modal-open").removeAttr("style");
  });
  jQuery('#warning-modal-comment').modal();
};

// window.positiveMessage()
window.positiveMessage = function () {
  var message = "You have left your first comment... <b>Good work</b>! <br><br>\n\n                    You can edit your profile to let people know more about you and change your profile image <a href='https://local.metaspoon.com/user/{username}/?em=first_comment'>here</a>.\n                    <br>In the profile section you can check out all the comments and votes you've made on Metaspoon.\n\n                    <br>Thanks for participating in the comminuity and looking forward to seeing more of you!";
  window.qipModalPositiveMessage(message);
};

/*
    Copied from themes just to have in case the other one doesnt work
 */
window.getDevice = function () {
  var device;
  device = 'm';

  /* This decided what platform is being used depending on screensize and orientation */
  if (screenwidth > 991) {
    device = 'd'; //sets platform as desktop
  } else if (screenwidth <= 991 && screenwidth > 599) {
    device = 't'; //sets platform as tablet
  } else if (screenwidth <= 599) {
    device = 'm'; //sets platform as mobile
  } else {
    device = 'n';
  }
  return device;
};

/*
    Keeps track if a page was viewed multiple times within a period of time and gives warning if so
   Does this by using local storage or cookies
 */
/*
        Keeps track if a page was viewed multiple times within a period of time and gives warning if so
       Does this by using local storage or cookies
     */
var GalleryMode = /*#__PURE__*/function () {
  function GalleryMode() {
    _classCallCheck(this, GalleryMode);
    /*
        Add event for "Disable Gallery Mode" and "Enable Gallery Mode" buttons in menu
     */
    this.add_menu_button_events();

    /*
        Set global window.device variable if not already set
     */
    this.setScreenWidthFunction();

    /*
        Only run on tablets and phones - exit if on desktop
          //check sitewide variable to check if running on desktop
        //if we cant find it then create a vesion of it
     */
    // if(window.device === 'd') return;
    // if(!window.device && document.documentElement.clientWidth > 911) return;
    if (window.debugMTS === "1") console.log('gallery mode - constructor running - 1!');

    /*
        Set variables
          max_time_to_track_in_seconds: max amount to of time to keep local storage variables for individual pages before deleting them.
        This is what clears the specific urls and the number of times they were visited.
    */

    /*
        Set wether we want to send users to cloud layout or gallery mode
     */
    this.cloud_layout_mode = true;
    if (this.cloud_layout_mode) this.gallery_modal_id = 'mts_cloud_layout_mode_modal';else this.gallery_modal_id = 'mts_gallery_mode_modal';
    this.alwaysShowGalleryInSopostsIfSelected = false; //if set to true, it will always check if a user set the settings to
    //gallery mode, and moving forward it will always auto detect if the user is in a sopost and redirect if not in a gallery already (doesnt work the other way around)
    this.max_time_to_track_in_seconds = 7200; //max amount to of time to keep local storage variables before deleting them
    this.platformsToRunModalOn = ["m", "t"]; //the platforms we should be running the modals for (if not included, the modal wont pop up)
    this.max_num_times_to_show_message = 1; //max number of times after a reload to show message offering gallery
    this.start_showing_message_at_x_number_of_times_reloaded = 2; //start showing message after page load this number of times
    this.current_page = window.location.href;
    this.current_time = Date.now();

    /*
        Redirect to gallery if user settings are set to show gallery in local storage
        Dont do it the other way (ie. if user is set to normal articles but goes to gallery dont redirect them)
    */
    if (this.alwaysShowGalleryInSopostsIfSelected === true && this.checkGalleryModeSetting() === "enabled") this.enableGalleryMode();

    /*
        If we have already set a specific setting for gallery mode, then we dont need to show the popup again
        so quit the constructor
          If the current page is already a gallery we dont need to show the popup either so  quit the constructor
            NOTE: For now we will still show the popup even if the user has previously clicked on "No thanks!" so
        we will comment this out
     */
    // if(this.checkGalleryModeSetting() !== "notset") return;

    /*
        If the current page is already a gallery we dont need to show the popup
     */
    if (this.isCurrentPageGallery() === true) {
      if (window.debugMTS === "1") console.log('Quitting gallery mode - already in gallery!');
      return;
    }

    /*
        If the current page is not a sopost then don't run script
     */
    if (this.isCurrentPageASopost() !== true) {
      if (window.debugMTS === "1") console.log('Quitting gallery mode - current page is not a sopost!');
      return;
    }

    /*
        Clear out any record that are past the max time to track from local storage
    */
    this.clearOutOldRecordsPastMaxTimeToTrack();

    /*
        If we want to run the modal on the current platform run the necessary
        steps and checks and launch the modal
     */
    if (this.shouldWeRunModalsOnThisPlatform()) {
      if (window.debugMTS === "1") console.log('Running modal - cirrect platform!');
      this.runModal();
    } else {
      if (window.debugMTS === "1") console.log('NOT running modal, ubcirrebt okatfirns');
    }
  }

  /*
      Run all the processes to check for the modal
   */
  return _createClass(GalleryMode, [{
    key: "runModal",
    value: function runModal() {
      if (window.debugMTS === "1") console.log('runModal script running!');

      /*
          Check if the current page is already being tracked in the localStorage variable
          If it is then check if we need alert and update
          If its not then create a new array and save it to local storage
       */
      var mts_page_viewed_times_array = this.getMtsPageViewedArrayFromSessionAsArray();
      if (window.debugMTS === "1") console.log('mts_page_viewed_times_array:', mts_page_viewed_times_array);

      /* If page has not been added to entry in local storage then add a fresh copy and quit constructor */
      if (mts_page_viewed_times_array === null || mts_page_viewed_times_array.length === 0) {
        if (window.debugMTS === "1") console.log('array in local storage not found - creating new array!');
        this.addEntryToMtsPageViewedArray(this.current_page, this.current_time, this.current_time);
        return;
      }

      /*
          Check if the current page is already in local storage and if so decide wether to show warning
          and update the variable
      */
      var page_already_exists = false;
      for (var i = 0; i < mts_page_viewed_times_array.length; i++) {
        if (window.debugMTS === "1") console.log(i + ' - ' + mts_page_viewed_times_array[i]);

        /* Check if current page already exists */
        if (mts_page_viewed_times_array[i]['current_page'] === this.current_page) {
          page_already_exists = true;

          // if(window.debugMTS === "1" ) console.log('Page has been found!');
          // if(window.debugMTS === "1" ) console.log('current time:', this.current_time);

          var times_viewed = mts_page_viewed_times_array[i].times_viewed;
          var first_time = mts_page_viewed_times_array[i].first_time;

          /*
              If page exists update the time stamp and increase the number of times viewed etc
          */
          times_viewed++;
          this.updateEntryInMtsPageViewedArray(this.current_page, this.current_time, first_time, times_viewed);

          /*
              Check if we need to give warning
                Do this by checking the the max amount of time has passed since reload and the number of times viewed is > 1
            */
          if (times_viewed >= this.start_showing_message_at_x_number_of_times_reloaded && times_viewed < this.start_showing_message_at_x_number_of_times_reloaded + this.max_num_times_to_show_message) {
            if (window.debugMTS === "1") console.log('XXXXXX SHOWING WARNING MESSAGE!');
            this.activateModal();
          }
        }
        //if the page doest yet exist then add it
      }

      /*
          If the specific page doesnt yet exist then add it
      */
      if (page_already_exists === false) {
        this.addEntryToMtsPageViewedArray(this.current_page, this.current_time, this.current_time);
      }
    }

    /*
        Return object with local stortage data  array for pages as an object
        returns: (obj), contains new_mts_page_viewed_times_obj from local session
     */
  }, {
    key: "getMtsPageViewedArrayFromSessionAsArray",
    value: function getMtsPageViewedArrayFromSessionAsArray() {
      //convert object with page data to json
      var mts_page_viewed_times_array = JSON.parse(localStorage.getItem('mts_page_viewed_times_array'));

      // console.log('JSON.parse(localStorage.getItem(\'mts_page_viewed_times_array\'));:',JSON.parse(localStorage.getItem('mts_page_viewed_times_array'))
      //if it is empty return an empty array
      if (mts_page_viewed_times_array === null) mts_page_viewed_times_array = [];
      return mts_page_viewed_times_array;
    }

    /*
        Updated a record in the mts page viewed array in local storage with new variables
          last_time: (string), timestamp of time page was viewed
        first_time: (string), timestamp of time first time page was viewed
        page: (string), the full url inc parameters of the page we want to update
        times_viewed: (int), the number of times the selected page was viewed
    */
  }, {
    key: "updateEntryInMtsPageViewedArray",
    value: function updateEntryInMtsPageViewedArray(page, last_time, first_time, times_viewed) {
      //delete the specific entry
      this.deleteEntryFromMtsPageViewedArray(page);

      //then add a new updated entry with new data
      this.addEntryToMtsPageViewedArray(page, last_time, first_time, times_viewed);
    }

    /*
        Adds an entry at the end of the the mts page view array in local storage
          last_time: (string), timestamp of time page was viewed
        first_time: (string), timestamp of time first time page was viewed
          current_page: (string), the full url inc parameters of the page we are keeping track of
        times_viewed: (int), the number of times the selected page was viewed - if there is no existing times_viewed set it to 1
     */
  }, {
    key: "addEntryToMtsPageViewedArray",
    value: function addEntryToMtsPageViewedArray(current_page, last_time, first_time) {
      var times_viewed = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;
      var new_page_viewed_times_obj = {
        'current_page': current_page,
        'last_time': last_time,
        'first_time': first_time,
        'times_viewed': times_viewed
      };

      //get the existing local storage as an array
      var mts_page_viewed_times_array = this.getMtsPageViewedArrayFromSessionAsArray();
      // console.log('pulling from local storage mts_page_viewed_times_array:',mts_page_viewed_times_array)

      /*
          If we dont have an existing array in local storage yet, then create a new one
       */
      if (mts_page_viewed_times_array === null) {
        mts_page_viewed_times_array = [];
        // console.log('before adding anything - jus created mts_page_viewed_times_array:',mts_page_viewed_times_array)
      }

      //add page viewed object to array
      mts_page_viewed_times_array.push(new_page_viewed_times_obj);

      // console.log('after adding variable mts_page_viewed_times_array:',mts_page_viewed_times_array)

      //convert to JSON
      var mts_page_viewed_times_array_json = JSON.stringify(mts_page_viewed_times_array);

      //save in local storage
      localStorage.setItem('mts_page_viewed_times_array', mts_page_viewed_times_array_json);
    }

    /*
        Deletes an entry from the MtsPageView array in local storage
          page: (string), the url of the page for the entry we want to delete from local storage
    */
  }, {
    key: "deleteEntryFromMtsPageViewedArray",
    value: function deleteEntryFromMtsPageViewedArray(page) {
      var mts_page_viewed_times_array = this.getMtsPageViewedArrayFromSessionAsArray();

      /*
          Check if the current page is already in local storage and also delete
      */
      for (var i = 0; i < mts_page_viewed_times_array.length; i++) {
        if (mts_page_viewed_times_array[i].current_page === page) {
          // console.log('ITEM BEFORE DELETE:',mts_page_viewed_times_array)
          mts_page_viewed_times_array.splice(i, 1); //delete element from array
          // console.log('ITEM AFTER DELETE:',mts_page_viewed_times_array)
          //convert to JSON
          var mts_page_viewed_times_array_json = JSON.stringify(mts_page_viewed_times_array);
          //save in local storage
          localStorage.setItem('mts_page_viewed_times_array', mts_page_viewed_times_array_json);
          // console.log('page deleted from array : ',page);
        }
      }
    }

    /*
        Gets the amount of time difference between two dates
        date1/date2: (int), timestamp difference between two dates
          returns: (int), absolute difference in seconds between the two dates
     */
  }, {
    key: "timeDifference",
    value: function timeDifference(date1, date2) {
      var difference = date1 - date2;
      var secondsDifference = Math.floor(difference / 1000);

      // console.log('difference = ' +
      //     secondsDifference + ' second/s ');

      return Math.abs(secondsDifference);
    }

    /*
        Clear out any old record from local storage that are past max time to track
     */
  }, {
    key: "clearOutOldRecordsPastMaxTimeToTrack",
    value: function clearOutOldRecordsPastMaxTimeToTrack() {
      var current_time = Date.now();
      var mts_page_viewed_times_array = this.getMtsPageViewedArrayFromSessionAsArray();

      //if the record doesnt exists then leave function
      if (!mts_page_viewed_times_array) return;

      //delete old entries in array
      for (var i = 0; i < mts_page_viewed_times_array.length; i++) {
        var time_in_storage = mts_page_viewed_times_array[i].first_time;
        var time_diff_since_first_view = this.timeDifference(current_time, time_in_storage);

        /* Delete any pages in storage that were visited more than the max time alloted */
        if (time_diff_since_first_view > this.max_time_to_track_in_seconds) {
          // console.log('DELETING ENTRY!!!',i)
          this.deleteEntryFromMtsPageViewedArray(mts_page_viewed_times_array[i].current_page);
        }
      }
    }

    /*
        Display modal with warning message and set events
     */
  }, {
    key: "activateModal",
    value: function activateModal() {
      if (window.debugMTS === "1") console.log('in activate modal!');
      console.log('in activate modal - calling:' + this.gallery_modal_id);
      var _self = this;
      jQuery("#".concat(_self.gallery_modal_id)).modal('show');

      // Track when modal shows up in google annalytics
      ga('send', 'event', 'gallery', 'Displayed gallery mode modal - page viewed ' + _self.getVariableFromPageViewedArray('times_viewed', window.location.href) + ' times', window.location.href);

      /*
          Add event listener for enabling galleries in modal
       */
      jQuery("#mts_modal_enable_gallery_mode").click(function () {
        if (window.debugMTS === "1") console.log('event gallery mode enabled!');

        // Set google analytics event and in the callback enable the gallery mode
        ga('send', 'event', 'gallery', 'Enabled gallery mode from modal - page viewed ' + _self.getVariableFromPageViewedArray('times_viewed', window.location.href) + ' times', window.location.href, {
          'hitCallback': function hitCallback() {
            _self.enableGalleryMode();
          }
        });
      });

      /*
          Add event listener for enabling cloud layout in modal
       */
      jQuery("#mts_modal_enable_cloud_layout_mode").click(function () {
        if (window.debugMTS === "1") console.log('event gallery mode enabled!');
        _self.enableCloudLayoutMode();
      });

      /*
          Add event listener for disabling galleries
       */
      jQuery("#mts_modal_disable_gallery_mode").click(function () {
        if (window.debugMTS === "1") console.log('event gallery mode disabled!');

        // Set google analytics event and in the callback disable the gallery mode
        ga('send', 'event', 'gallery', 'Selected "no thanks" from gallery mode modal - page viewed ' + _self.getVariableFromPageViewedArray('times_viewed', window.location.href) + ' times', window.location.href);
      });

      /*
          Add event listener for x-out from gallery modal
       */
      jQuery("#mts_gallery_mode_modal .close").click(function () {
        if (window.debugMTS === "1") console.log('event gallery mode modal x-outed!');

        // Set google analytics event and in the callback disable the gallery mode
        ga('send', 'event', 'gallery', 'X-out from gallery mode modal - page viewed ' + _self.getVariableFromPageViewedArray('times_viewed', window.location.href) + ' times', window.location.href);
      });
    }

    /*
        Check if gallery mode is enabled by checking locals storage, returns "enabled" if enabled, and "disabled" if disabled
        and "notset" if it hasnt been set yet
          returns: (string), "enabled" if enabled, and "disabled" if disabled and "notset" if it hasnt been set yet
       */
  }, {
    key: "checkGalleryModeSetting",
    value: function checkGalleryModeSetting() {
      //check local storage
      var mts_gallery_mode_setting = localStorage.getItem('mts_gallery_mode_setting');
      if (mts_gallery_mode_setting === "enabled") return "enabled";else if (mts_gallery_mode_setting === "disabled") return "disabled";else return "notset";
    }

    /*
        Enable gallery mode
        Adds local storage variable to save setting and reloads page with gallery mode if not already in gallery mode
     */
  }, {
    key: "enableGalleryMode",
    value: function enableGalleryMode() {
      /*
          Add variable to local storage to save user setting for gallery mode
      */
      localStorage.setItem('mts_gallery_mode_setting', 'enabled');

      /* Delete settings for specific page from localstorage page array*/
      this.deleteEntryFromMtsPageViewedArray(this.current_page); //why do we need to do this? It means after reload a couple times it will again pop up modal

      //if current page is not a gallery page then add gl=1 to url and reload page
      if (!this.isCurrentPageGallery()) {
        var full_url = window.location.href;
        var url = new URL(full_url);
        var params = new URLSearchParams(url.search);
        params.set('gl', 1);
        var new_url = window.location.origin + window.location.pathname + '?' + params.toString();
        window.location.href = new_url;
      }
    }

    /*
        Enable Cloud Layout mode
        Very simply reloads page in cloud layout
     */
  }, {
    key: "enableCloudLayoutMode",
    value: function enableCloudLayoutMode() {
      console.log('xxx in enableCloudLayoutMode');
      var currentURL = new URL(window.location.href);
      var pathSegments = currentURL.pathname.split('/').filter(function (segment) {
        return segment.length > 0;
      });

      // If the first segment is not 'cl', add it.
      if (pathSegments[0] !== 'cl') {
        pathSegments.unshift('cl');
      }
      currentURL.pathname = '/' + pathSegments.join('/');

      // 1. To redirect to the new URL:
      // window.location.href = currentURL.toString();

      // window.history.replaceState({}, document.title, currentURL.toString());

      console.log('xxx new url:', currentURL.toString());
      window.location.href = currentURL.toString();
    }

    /*
        Disable gallery mode
        Adds local storage variable to save setting and reloads the page to not be in gallery mode if not already out of gallery mode
     */
  }, {
    key: "disableGalleryMode",
    value: function disableGalleryMode() {
      /*
          Add variable to local storage to save user setting for gallery mode
      */
      localStorage.setItem('mts_gallery_mode_setting', 'disabled');

      /* Delete settings for specific page from localstorage page array*/
      this.deleteEntryFromMtsPageViewedArray(this.current_page); //why do we need to do this? It means after reload a couple times it will again pop up modal

      //if current page is gallery then remove gl variable and reload page to go to non gallery version
      if (this.isCurrentPageGallery()) {
        var full_url = window.location.href;
        var url = new URL(full_url);
        var params = new URLSearchParams(url.search);
        params["delete"]('gl');
        var new_url;
        if (params.toString() === "" || params.toString() === null) new_url = window.location.origin + window.location.pathname;else new_url = window.location.origin + window.location.pathname + '?' + params.toString();
        window.location.href = new_url;
      }
    }

    /*
        Check if current page is gallery or not by looking to see if gl= has a value in the url.
        If it has a value then it assumes the current page is a gallery
          returns: (bool), true if current page is a gallery and false if not
     */
  }, {
    key: "isCurrentPageGallery",
    value: function isCurrentPageGallery() {
      var queryString = window.location.search;
      var urlParams = new URLSearchParams(queryString);
      var gl = urlParams.get('gl');
      if (gl === null || gl === "") return false;
      return true;
    }

    /*
        Check if current page is a sopost or not
          returns: (bool), true if current page is a sopost and false if not
     */
  }, {
    key: "isCurrentPageASopost",
    value: function isCurrentPageASopost() {
      if (window.page_type === "sopost") return true;
      return false;
    }

    /*
        Add event listeners to enable and disable gallery mode from the menu on the left side
        as well as a hidden just for admins to delete all preferences from local storeage
     */
  }, {
    key: "add_menu_button_events",
    value: function add_menu_button_events() {
      var _self = this;

      /*
          Button to delete all gallery user preferences
       */
      if (document.getElementById("mts_menu_delete_gallery_preferences")) {
        document.getElementById("mts_menu_delete_gallery_preferences").addEventListener("click", function () {
          if (window.debugMTS === "1") console.log('deleted all gallery user preferences!');
          _self.deleteAllGalleryLocalStorageVarsFromBrowser();

          // Set google analytics event and in the callback enable the gallery mode
          ga('send', 'event', 'gallery', 'Admin - cleared all local storage variables', window.location.href, {
            'hitCallback': function hitCallback() {
              _self.deleteAllGalleryLocalStorageVarsFromBrowser();
            }
          });
        });
      }

      /*
          Button to enable gallery user preferences and reload page if necessary
       */
      if (document.getElementById("mts_menu_enable_gallery_mode")) {
        document.getElementById("mts_menu_enable_gallery_mode").addEventListener("click", function () {
          if (window.debugMTS === "1") console.log('enabled gallery mode!');

          // Set google analytics event and in the callback enable the gallery mode
          ga('send', 'event', 'gallery', 'Enabled gallery mode from menu', window.location.href, {
            'hitCallback': function hitCallback() {
              _self.enableGalleryMode();
            }
          });
        });
      }

      /*
          Button to disable gallery user preferences and reload page if necessary
       */
      if (document.getElementById("mts_menu_disable_gallery_mode")) {
        document.getElementById("mts_menu_disable_gallery_mode").addEventListener("click", function () {
          if (window.debugMTS === "1") console.log('disabled gallery mode!');

          // Set google analytics event and in the callback enable the gallery mode
          ga('send', 'event', 'gallery', 'Disabled gallery mode from menu', window.location.href, {
            'hitCallback': function hitCallback() {
              _self.disableGalleryMode();
            }
          });
        });
      }
    }

    /*
        Delete all gallery local strage variables from browser
     */
  }, {
    key: "deleteAllGalleryLocalStorageVarsFromBrowser",
    value: function deleteAllGalleryLocalStorageVarsFromBrowser() {
      localStorage.removeItem('mts_gallery_mode_setting');
      localStorage.removeItem('mts_page_viewed_times_array');
    }

    /*
        Checks wether we should run the Modals to check gallery on current platform
          returns: (bool), true if we should run modal on current device and false if we shouldnt
     */
  }, {
    key: "shouldWeRunModalsOnThisPlatform",
    value: function shouldWeRunModalsOnThisPlatform() {
      if (this.platformsToRunModalOn.includes(window.device)) return true;
      return false;
    }

    /*
        If not provided then create screenwidth funtions
     */
  }, {
    key: "setScreenWidthFunction",
    value: function setScreenWidthFunction() {
      //if we have window.device already set we can skip this, otherwise set the variables
      if (typeof window.device !== 'undefined') return;
      window.screenwidth = document.documentElement.clientWidth;

      /*
          Function for getting current device based on width
            returns: (string), a character representing the device (m = mobile, d = desktop, t = tablet)
      */

      window.getDevice = function () {
        var device;
        device = 'm';

        /* This decided what platform is being used depending on screensize and orientation */
        if (screenwidth > 991) {
          device = 'd'; //sets platform as desktop
        } else if (screenwidth <= 991 && screenwidth > 599) {
          device = 't'; //sets platform as tablet
        } else if (screenwidth <= 599) {
          device = 'm'; //sets platform as mobile
        } else {
          device = 'n';
        }
        return device;
      };

      /* For now we will have a variable for device but we should use the function */
      window.device = window.getDevice();
    }

    /*
        Return variable from the time viewed array
        var_name: (string), the variable name we want to get from the page vieewed array
        page: (string), the page we want to pull the variable for
          returns: (string), the value for the variable we are looking for, if not found returns null
     */
  }, {
    key: "getVariableFromPageViewedArray",
    value: function getVariableFromPageViewedArray() {
      var var_name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var page = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var mts_page_viewed_times_array = this.getMtsPageViewedArrayFromSessionAsArray();
      if (!var_name) {
        if (window.debugMTS === "1") console.log('Error: cant return value, no var name provided');
        return null;
      }
      if (!page) {
        if (window.debugMTS === "1") console.log('Error: cant return value, no url provided');
        return null;
      }

      /*
          Check if the current page is already in local storage and if so save value to variable
      */
      var found_value = null; // will hold the object if found in array

      for (var i = 0; i < mts_page_viewed_times_array.length; i++) {
        if (mts_page_viewed_times_array[i].current_page === page) {
          found_value = mts_page_viewed_times_array[i];
          break;
        }
      }

      //if the url does not exist in array then return blank
      if (found_value === null) {
        if (window.debugMTS === "1") console.log('URL does not exists in array (', page, ')');
        return "";
      }
      if (found_value[var_name]) return found_value[var_name];
      if (window.debugMTS === "1") console.log('Error: var name not found in array (', var_name, ')!');
      return null;
    }
  }]);
}();
$(document).ready(function () {
  new GalleryMode();
});
window.QipComments = /*#__PURE__*/function () {
  function _class() {
    _classCallCheck(this, _class);
    var _self = this;
    console.log('Qip comments initialized');

    /*
       Set event listeners
         !--- dont run this be default - we may want to use functions in comments for Story Feed before running
       the event listeners, so we do this manually when initializing it
      */
    // _self.setEventListeners();
  }
  /*
      Grabs the variables necessary to submit a comment
      This can be ran at the time we submit a comment. The reason is that a user can log in after the comment class
      has already been intialized so the nonce, author name, etc will change
        We will try to grab the variables first from the wp_localize variables and if they are not found then from
      the body tag in the html where we have set a copy of the nonce, author, etc
   */
  return _createClass(_class, [{
    key: "setCommentVariables",
    value: function setCommentVariables() {
      var _self = this;
      if (window.qip_is_user_logged_in()) {
        /*
            Set up variables
              First look for the wp_localize variables and if not found there, then look for it as an
            attribute in the body tag (put there for loggin in without page reload)
           */

        //set ajax url
        if (typeof ajaxurl === "undefined") {
          _self.ajaxurl = document.body.getAttribute('ajaxurl');
        } else {
          _self.ajaxurl = qip_ajax_url;
        }

        /*
              Get username and displayname for user
              First check if we set it in the body tags, meaning we just changed user/display name or just logged in/registered
              If we dont have them there, then check for the variables from wp localize
           */
        /*
            If username/display name was set up in the body thorugh javascript (ie. we changed them or just logged in/registeed
            Then use the settings in body tags
         */
        if (document.body.getAttribute('user_name')) {
          _self.author_login_name = document.body.getAttribute('user_name');
          _self.author_display_name = document.body.getAttribute('display_name');
        }
        /*
            If user was already logged in we should already hav the user login and display name
         */else {
          _self.author_login_name = qip_comments_author_login_name;
          _self.author_display_name = qip_comments_author_display_name;
        }

        /*
            Set profile image url - either from variables in localize or in the body tags if we just logged in
              If we have the profile image set in the body tag, it means we just either changed it or just logged in
            so it has priority.
              If we dont have it in the body tag, then fall back to the 'qip_profile_image_small' that was set up through the
            localize script when enquued
         */
        if (document.body.getAttribute('small_profile_image')) {
          // console.log('using small profile image from body')
          _self.profile_image = document.body.getAttribute('small_profile_image');
        } else {
          // console.log('using small profile image from wp localize')
          _self.profile_image = qip_profile_image_small;
        }
      }
    }

    /*
        Set event listeners so that when people submit a comment buttons react
     */
  }, {
    key: "setEventListeners",
    value: function setEventListeners() {
      var _self = this;
      var article_id; //the article id for each submit button
      var form_data; //data for selected form

      /*
          Add actions for all submit buttons
       */
      this.addActionForAllSubmitCommentButtons();

      /*
          Add actions for all edit/delete buttons
       */
      this.addActionForAllEditAndDeleteCommentButtons();

      /*
          Add actions for all view more comments at the END OF COMMENTS
       */
      this.addActionForAllMoreCommentsEndText();

      /*
          Add an event listener to detect when user clicks on any REPLY button so we can do an ajax query to
          add a reply box
       */
      this.addActionForAllReplyButtons();

      /*
          Add event listener to "Load More Comments" text for replies
       */
      this.addActionForMoreCommentsForReplies();

      /*
          Add event listener to "Load More Comments" text for replies for FIRST COMMENT
       */
      this.addActionForMoreCommentsForRepliesForFirstComment();

      /*
          Initialize each comment box on screen
       */
      this.initializeCommentBoxes();

      /*
          Initialize comment overflow hidden and add action for expand comment button
      */
      this.intializeCommentOverflow();
    }
  }, {
    key: "addActionForAllSubmitCommentButtons",
    value:
    /*
        Add an event listener to detect when user clicks on any submit button so we can do an ajax query to
        submit the button to the comments
    */
    function addActionForAllSubmitCommentButtons() {
      console.log('xxx in     addActionForAllSubmitCommentButtons()');
      var _self = this;
      var submit_comment_buttons = document.getElementsByName('submit-comment');
      submit_comment_buttons.forEach(function (e) {
        /*
            Check if we have initialized this before so we dont initialize it again
            by checking if attribute 'init' is set to true. If not, lets add the attribute 'init' and set it to 'true'.
              If it has been initialized before then return and dont initialize again.
         */
        if (e.getAttribute('init')) return;else {
          e.setAttribute('init', 'true');
        }
        var article_id = e.getAttribute('article-id');
        var sopost_id = jQuery(e).closest(".metaspoon-comments").attr('sopost-id');

        //add event listener to post button
        e.addEventListener('click', function () {
          //if user is not logged in then let user know they must be logged in
          if (!window.qip_is_user_logged_in()) {
            window.launchMustBeLoggedIn('You must be logged in to comment. You can log in directly without registering by clicking on the Facebook/Google button below!');
          }
          //if user is not verified then launch warning message
          else {
            /*
                Checks if user is verified
             */
            window.qip_check_is_user_verified(function (is_verified) {
              // console.log('IS VERIFIED:',is_verified)
              //if user is not verified then show error
              if (!is_verified) {
                window.qipModalWarning('Sorry, you must verify your email before you can post comments.');
              }
              //if user is verified then proceed
              else {
                var form_data;

                /*
                    Find out if this post button is for the top textarea in story comments or a reply
                      If its a top text area then element id will be 'comment-form-top-textarea-${article_id}'
                    if its a reply it will be 'comments-form-${article_id}'
                 */
                var top_textarea = e.getAttribute('is-top-textarea');
                if (top_textarea === "true") {
                  var comment_top_textarea = document.getElementById("comments-form-top-textarea-".concat(article_id));
                  form_data = new FormData(comment_top_textarea);
                  /* Empty out comments from top of comments textarea */
                  comment_top_textarea.getElementsByClassName('comment-text')[0].value = '';
                } else {
                  form_data = new FormData(document.getElementById("comments-form-".concat(article_id)));
                }

                /*
                    If there is no data in comment then dont let it post!
                 */
                if (form_data.get('comment').length < 1) return;

                /*
                    Submit the comment ajax call
                 */
                // console.log('form_data:',form_data)
                // console.log('article_id:',article_id)
                // console.log('sopost_id:',sopost_id)
                // console.log('e:',e)
                _self.ajaxCallSubmitComment(form_data, article_id, sopost_id, e);
              }
            });
          }
        });
      });
    }

    /*
        Add an event listener to detect when user clicks on any REPLY button so we can do an ajax query to
        add a reply box
     */
  }, {
    key: "addActionForAllReplyButtons",
    value: function addActionForAllReplyButtons() {
      var _self = this;
      var reply_comment_buttons = document.getElementsByName('qip-comment-reply');
      // console.log('reply buttons:',reply_comment_buttons);

      reply_comment_buttons.forEach(function (e) {
        /*
            Check if we have initialized this before so we dont initialize it again
            by checking if attribute 'init' is set to true. If not, lets add the attribute 'init' and set it to 'true'.
              If it has been initialized before then return and dont initialize again.
         */
        if (e.getAttribute('init')) return;else {
          e.setAttribute('init', 'true');
        }

        //add event listener to REPLY button
        e.addEventListener('click', function () {
          var comment_id = e.getAttribute('comment-id');
          var article_id = e.getAttribute('article-id');
          _self.addReplyBox(article_id, comment_id);
        });
      });
    }

    /*
        Inserts one element after an existing element in html dom
          newNode: (string), the new html element you want to insert
        referenceNode: (string), the html you want to insert some hing after
     */
  }, {
    key: "insertAfter",
    value: function insertAfter(newNode, referenceNode) {
      referenceNode.parentNode.insertBefore(newNode, referenceNode.nextSibling);
    }

    /*
        Adds a reply form below a comment to be able to reply
          comment_id: (int), the id of the comment box we are replying in (ie the parent comment)
     */
  }, {
    key: "addReplyBox",
    value: function addReplyBox(article_id, comment_id) {
      this.removeAllReplyBoxesForArticle(article_id);

      // console.log('COMMENT ID WE ARE INSERTING AFTER:',comment_id);

      var current_comment_reply_div = document.getElementById("qip-comment-children-".concat(comment_id));
      //insert comment box after reply button
      this.insertAfter(this.replyForm(article_id, comment_id), current_comment_reply_div);
      //add event for comment button
      this.addActionForAllSubmitCommentButtons();
      //hide reply button
      this.hideReplyButton(current_comment_reply_div);

      // Initialize Textarea Autosize
      jQuery('.textarea-autosize').textareaAutoSize();
    }

    /*
        Makes all reply buttons visible and then hides the specific reply button we need to hide
          comment_id: (obj), the div we want to hide
     */
  }, {
    key: "hideReplyButton",
    value: function hideReplyButton(current_comment_reply_div) {
      //make all reply buttons visible
      document.querySelectorAll('.qip-comment-reply').forEach(function (e) {
        e.style.display = "block";
      });

      //hide specific reply button
      current_comment_reply_div.style.display = "none";
    }

    /*
        Creates a dom element with the reply box
          comment_id: (int), the id of the comment we are replying to
     */
  }, {
    key: "replyForm",
    value: function replyForm(article_id, comment_id) {
      var el = document.createElement("span");
      el.innerHTML = "\n        \n        <form class=\"qip-comments-form mt-2 mb-3\" id=\"comments-form-".concat(article_id, "\">\n\n            <div class=\"input-group\"> \n                <textarea class=\"form-control comment-text textarea-autosize\" name=\"comment\" id=\"comment\" aria-label=\"With textarea\"  placeholder=\"Add your comment...\"></textarea>\n                <div class=\"input-group-append\">\n                    <span class=\"input-group-text submit-comment\" article-id=\"").concat(article_id, "\" name=\"submit-comment\">Post</span>\n                </div>\n            </div>\n            <input type=\"hidden\" name=\"comment-id\" value=\"").concat(comment_id, "\">\n            <input type=\"hidden\" name=\"article-id\" value=\"").concat(article_id, "\">\n\n\n        </form>\n        \n        ");
      return el;
    }

    /*
        Creates a dom element simulating a reply
          parent_comment_id: (int), the comment below which this comment will display
        comment_text: (string), the comment text user submitted
        article_id: (int), the article id we are posting comment for
        new_comment_id: (int), the id of the new comment we have just posted
     */
  }, {
    key: "addSimulatedReply",
    value: function addSimulatedReply(parent_comment_id, comment_text, article_id, new_comment_id) {
      var _self = this;

      //grabs author image,name, ajax url, nonce, etc and save it to 'this' object
      this.setCommentVariables();

      //replace line breaks for <br> in order to properly show the user's comments with spaces
      comment_text = comment_text.split('\n').join('<br>');

      /*
          Create the comment
       */
      var sim_reply = document.createElement("span");
      sim_reply.innerHTML = "\n        \n            <div class=\"comment-box media simulated-reply\" id=\"comment-box-".concat(new_comment_id, "\"  comment-id=\"").concat(new_comment_id, "\">\n            <a href=\"/user/").concat(this.author_login_name, "\" target=\"_blank\">\n                <img class=\"rounded-circle comment-image\" src=\"").concat(this.profile_image, "\" alt=\"Generic placeholder image\" height=\"25\" width=\"25\">\n            </a>\n            <div class=\"media-body\">\n                \n                <div class=\"d-flex\">\n                    <div class=\"mr-auto p-2\" style=\"padding: 0px!important\">\n                        <span class=\"comment-user mt-0\"><a href=\"/user/").concat(this.author_login_name, "\" target=\"_blank\">").concat(this.author_display_name, "</a></span></span>\n                        <span class=\"comment-time\">Just now</span>\n                    \n                    \n                        <div class=\"btn-group dropright\" id=\"qip_comments_kebab_menu_").concat(new_comment_id, "\">\n                            <span class=\"qip_comments_kebab ml-2\" type=\"button\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\">\n                                <i class=\"fas fa-ellipsis-v fa-xs\"></i>\n                            </span>\n                            <div class=\"qip-kebab-dropdown-menu dropdown-menu shadow ml-2 mb-5 bg-white rounded\" style=\"width:10px!important;\">\n                                <div class=\"menu-item qip_edit_comment_button\" comment-id=\"").concat(new_comment_id, "\"><i class=\"fas fa-edit\" style=\"width:20px;\"></i> Edit</div>\n                                <div class=\"menu-item qip_delete_comment_button\" comment-id=\"").concat(new_comment_id, "\"><i class=\"far fa-trash-alt\" style=\"width:20px;\"></i> Delete</div>\n                            </div>\n                        </div>      \n                    </div>                     \n                </div>\n                \n                 <span class='qip-comment-text' id='qip-comment-text-").concat(new_comment_id, "'>").concat(comment_text, "</span>\n            </div>\n        \n        ");
      // console.log('reply form:',sim_reply)

      /*
          If this is a reply then add comment inside comment we are replying to,
          otherwise insert it at the top of the comments list
       */
      if (parent_comment_id === "0") {
        var comments_list = document.getElementById("commentlist-".concat(article_id));
        comments_list.insertBefore(sim_reply, comments_list.firstChild);
      } else {
        var div_to_insert_comment_below = document.getElementById("qip-comment-children-".concat(parent_comment_id));
        //insert comment box after reply button
        this.insertAfter(sim_reply, div_to_insert_comment_below);
      }

      /*
          Add action for edit and delete comments for new simulated comment
       */
      this.addActionForAllEditAndDeleteCommentButtons();
    }

    /*
        Removes all textarea comment boxes from the dom
     */
  }, {
    key: "removeAllReplyBoxesForArticle",
    value: function removeAllReplyBoxesForArticle(article_id) {
      //remove all reply boxes before we display new reply box
      document.querySelectorAll("#metaspoon-comments-".concat(article_id, " .qip-comments-form")).forEach(function (e) {
        //if its the first textarea do not remove only remove the replies
        if (e.classList.contains('comment-form-top')) {} else {
          e.remove();
        }
      });
    }

    /*
        Ajax call to submit comment to wordpress
          params: (form data object), contains all the data in comment form
        form: (form object), contains all form data needed for comment
        article_id: (string), the post id the current comment belongs to
        sopost_id: (string), the sopost id the current comment belongs to
       */
    // function ajaxCallSubmitComment(article_id, comment_text, parent_comment_id = null){
  }, {
    key: "ajaxCallSubmitComment",
    value: function ajaxCallSubmitComment(params, article_id, sopost_id, button_clicked) {
      var _self = this;

      //grabs author image,name, ajax url, nonce, etc and save it to 'this' object
      this.setCommentVariables();

      // console.log(params);
      // console.log('AJAX URL:',this.ajaxurl);

      params.append('sopost-id', sopost_id);
      params.append('action', 'qip_comment_submit');
      params.append('logged_in_nonce', logged_in_nonce);

      /*
          Add spinner on button clicked
       */
      var button_clicked_original_text = button_clicked.innerHTML;
      button_clicked.innerHTML = "\n                <div class=\"spinner-grow text-secondary\" role=\"status\" style=\"width: 25px;height:25px\">\n                    <span class=\"sr-only\">Loading...</span>\n                </div>\n        ";

      //do ajax query to password reset
      fetch(_self.ajaxurl, {
        method: 'POST',
        body: params
      }).then(function (res) {
        return res.json();
      })["catch"](function (error) {
        if (window.debugMTS === "1") {
          console.log('error with submission - ', error);
        }
      }).then(function (response) {
        // console.log(' aaa response:',response);

        if (window.debugMTS === "1") {
          console.log('response:', response);
        }
        if (response === 0 || !response.status) {
          /*
              Check if user is logged in and if not then launch a warning
           */
          if (window.debugMTS === "1") {
            console.log('Error posting comment - status:', status);
          }
          window.qipModalWarning(response.message);
        }

        /*
            If comment was succesfully added
         */
        if (response.status === true) {
          /* Remove the reply box if its not a top of comments textarea */
          _self.removeAllReplyBoxesForArticle(article_id);
          // /* Add a simulated version of the post so the user sees their post live right away */
          _self.addSimulatedReply(params.get('comment-id'), params.get('comment'), article_id, response.new_comment_id);
        }

        /*
            Reset post button to original text
         */
        button_clicked.innerHTML = button_clicked_original_text;
      });
    }

    /*
        --------------------------------- Get More Comments Button End ---------------------------------
    */

    /*
        Adds action to view more comments at the end of comments (not for individual nested comments)
     */
  }, {
    key: "addActionForAllMoreCommentsEndText",
    value: function addActionForAllMoreCommentsEndText() {
      var _self = this;
      var comments_lists_for_stories = document.querySelectorAll('.commentlist');
      comments_lists_for_stories.forEach(function (comment_list_for_story) {
        /*
            Check if we have initialized this before so we dont initialize it again
            by checking if attribute 'init' is set to true. If not, lets add the attribute 'init' and set it to 'true'.
              If it has been initialized before then return and dont initialize again.
         */

        var story_id = comment_list_for_story.getAttribute('story-id');

        /*
            If story has no comments then exit function as no need to initialize more comments button
         */
        var more_comments_button = document.getElementById("more-comments-end-text-".concat(story_id));
        if (more_comments_button === null) return;
        if (more_comments_button.getAttribute('init')) return;else {
          more_comments_button.setAttribute('init', 'true');
        }

        //add event listener to post button
        more_comments_button.addEventListener('click', function () {
          /*
              If we haven't already, trigger "clicking" the comment for the first comment so
              we also unhide that first comment if we havent already
           */

          var first_comment_initial_load_more_link = document.getElementById("qip-load-more-comments-text-first-comment-for-storyid-".concat(story_id));
          if (first_comment_initial_load_more_link) first_comment_initial_load_more_link.click();

          /*
              Make any currently hidden comments for this section visible
              This is because we only show a single comment and one reply for the first
              comment but the first comment might have more than one reply and it will be hidden
           */
          // console.log('pressed view more button');
          // const comment_list = document.getElementById(`commentlist-${story_id}`);
          // const hidden_comments = comment_list.getElementsByClassName("d-none");
          // console.log('list of elements with d-none',hidden_comments);
          // // regular for loop
          // for (let i = 0; i < hidden_comments.length; i++) {
          //     // console.log(hidden_comments[i]);
          //     hidden_comments[i].classList.remove("d-none");
          // }

          /*
              If this is a comment with only one comment (ie. attribute "only-one-comment" = "true")
              then all we need to do is make current comments visible, we dont need to pull any
              additional comments from ajax request so we can exit function (otherwise continue to pull more comments)
           */
          _self.intializeCommentOverflow();
          var only_one_comment = more_comments_button.getAttribute('only-one-comment');
          if (only_one_comment === "true") return;

          /*
              Get list of all comment-ids in current comment-list
              We need this because otherwise, comments we downvotes on may change order and when we
              get more comments they might be repeated
           */

          var comment_ids_to_exclude = comment_list_for_story.getAttribute('displayed-comment-ids-array');
          var article_id = more_comments_button.getAttribute('article-id');
          //find out how many contents we've loaded so far by checking the attribute in the view comments button
          var total_comments_loaded = more_comments_button.getAttribute('total_comments_loaded');
          _self.ajaxGetMoreCommentsForArticle(article_id, total_comments_loaded, comment_ids_to_exclude);
        });
      });
    }

    /*
        Ajax call to get more comments for article from wordpress
          article_id: (int), the post id of the article we want to load more comments for
        total_comments_loaded: (int), the total number of comments that have already been loaded for a specific article
       */
  }, {
    key: "ajaxGetMoreCommentsForArticle",
    value: function ajaxGetMoreCommentsForArticle(article_id) {
      var _this = this;
      var total_comments_loaded = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var comment_ids_to_exclude = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
      var _self = this;

      //grabs author image,name, ajax url, nonce, etc and save it to 'this' object
      this.setCommentVariables();
      var params = new FormData();
      params.append('action', 'qip_get_more_comments_for_article');

      //we need to submit both nonces, because logged in and logged out users will get more content
      if (typeof logged_in_nonce !== 'undefined') {
        params.append('logged_in_nonce', logged_in_nonce);
      }
      ;
      //if we dont have a logged_in_nonce set, then set it to blank
      params.append('qip_comments_nonce', qip_comments_nonce);
      params.append('article_id', article_id);
      params.append('total_comments_loaded', total_comments_loaded);
      params.append('comments_to_exclude', comment_ids_to_exclude);
      console.log('total_comments_loaded:', total_comments_loaded);
      console.log('comments_to_exclude:', comment_ids_to_exclude);
      //do ajax query to password reset
      fetch(ajaxurl, {
        method: 'POST',
        body: params
      }).then(function (res) {
        return res.json();
      })["catch"](function (error) {
        if (window.debugMTS === "1") {
          console.log('error with submission - ', error);
        }
      }).then(function (response) {
        if (window.debugMTS === "1") {
          console.log('response:', response);
        }
        if (response === 0 || !response.status) {
          /*
              Check if user is logged in and if not then launch a warning
           */
          if (window.debugMTS === "1") {
            console.log('Error: could not get additional comments');
          }
        }

        /*
            If comment was succesfully added
         */
        if (response.status === true) {
          // console.log('response:',response.comments_html);

          //update list of comments to exlclude in "displayed-comment-ids-array" value in parent div to comments
          //so we can exclude them in next pull
          var string_for_displayed_comment_ids_array = response.next_comments_ids_to_exclude_array_for_next_pull; //make string look like array for js
          document.getElementById("commentlist-".concat(article_id)).setAttribute('displayed-comment-ids-array', string_for_displayed_comment_ids_array);

          //visually insert comments into page
          _self.insertCommentsIntoList(article_id, response.comments_html);

          //update the total_comments_loaded number so we know where to start looking for the next round
          var load_more_comments_dom_obj = document.getElementById("more-comments-end-text-".concat(article_id));
          if (load_more_comments_dom_obj) {
            var updated_total_comments_loaded = parseInt(total_comments_loaded) + parseInt(response.num_of_new_ads_loaded);
            load_more_comments_dom_obj.setAttribute('total_comments_loaded', updated_total_comments_loaded);

            /*
                If total comments loaded is equal to total comments available then delete the more comments link
                  ie. if there are no more comments delete link
             */
            if (updated_total_comments_loaded >= response.total_comment_count_not_counting_replies) load_more_comments_dom_obj.remove();
          }

          /*
              Add event listener to "Load More Comments" text for Replies
           */
          _this.addActionForMoreCommentsForReplies();
        }
      });
    }

    /*
        Visually insert comments into comments list when user clicks on "view more content"
          article_id: (int), the article(story) for which we are inserting new comments
        comments_html: (string), the html code to insert for the new comments from wp
     */
  }, {
    key: "insertCommentsIntoList",
    value: function insertCommentsIntoList(article_id, comments_html) {
      /*
          Insert new comments above "view more comments div" more-comments-end-text-{id number} and then delete old
          more-comments-end-text-{id number} so we can add the new one with updated number of comments left
       */

      // Create a new element
      var newNode = document.createElement('div');
      newNode.innerHTML = comments_html;

      // Get the reference node
      var referenceNode = document.querySelector("#more-comments-end-text-".concat(article_id));

      //rename the `#more-comments-end-text-${article_id}` id so we can delete it after to make way for
      //the updated more-comments-end-text with the updated number of comments left to load
      referenceNode.id = "#more-comments-end-text-".concat(article_id, "-old");

      // Insert the new node before the reference node
      referenceNode.parentNode.insertBefore(newNode, referenceNode);

      // Now that we have inserted the new comments and new "more comment" button, we can delete the old "more comments" button
      referenceNode.remove();

      /* Add action for all "view more comments" links below comments */
      this.addActionForAllMoreCommentsEndText();

      /* Add action for new reply buttons */
      this.addActionForAllReplyButtons();

      /* Add action for new upvote buttons */
      this.initializeCommentBoxes();

      /* Add action to initialize edit/delete buttons */
      this.addActionForAllEditAndDeleteCommentButtons();

      /*
          Initialize comment overflow hidden and add action for expand comment button
      */
      this.intializeCommentOverflow();
    }

    /*
    --------------------------------- Load More Comments For Replies ---------------------------------
    */

    /*
        Adds action to view more comments for replies
     */
  }, {
    key: "addActionForMoreCommentsForReplies",
    value: function addActionForMoreCommentsForReplies() {
      var _self = this;

      // console.log('Running addActionForMoreCommentsForReplies()');

      /*
          Add actions to the "Load More Comments" buttons for comments
       */
      var more_comments_for_replies_text = document.querySelectorAll('.qip-load-more-comments-text');
      more_comments_for_replies_text.forEach(function (e) {
        //add event listener to post button
        e.addEventListener('click', function () {
          /*
              Check if we have initialized this before so we dont initialize it again
              by checking if attribute 'init' is set to true. If not, lets add the attribute 'init' and set it to 'true'.
                If it has been initialized before then return and dont initialize again.
           */
          if (e.getAttribute('init')) return;else {
            e.setAttribute('init', 'true');
          }

          /*
              Unhide comments when clicking on the load more replies button
                Grabs the parent "comment-box" and
              1- unhides any siblings if it has any (by looking the the parent comment id and grabbing list of children ids)
              This is necessary because a lot of times we JUST show the first reply, so for these we need to make sure that
              we show siblings as well
              2- unhides any children of its own (by looking at the current comment id and grabbing list of children ids)
           */
          // console.log('e:',e)

          /* First unhide sibling comments */
          var parent_comment_id = e.getAttribute('comment-parent-id');
          // console.log('parent comment id:',parent_comment_id)

          //unhide the comments for all comment in parent commends
          // var comment_boxes_within_parent_comment = document.getElementById(`comment-box-${parent_comment_id}`);
          // console.log(comment_boxes_within_parent_comment);
          var parent_comment_box = document.getElementById("comment-box-".concat(parent_comment_id));
          var sibling_comment_ids = parent_comment_box.getAttribute('children-ids');
          var sibling_comment_ids_array = sibling_comment_ids.split(',');
          // console.log('Sibling comment ids:',sibling_comment_ids)

          //get sibling divs and unhide them
          sibling_comment_ids_array.forEach(function (sibling_id) {
            var sibling_div = document.getElementById("comment-box-".concat(sibling_id));
            var is_hidden = sibling_div.classList.contains('d-none');
            if (sibling_div) {
              // console.log(`removing d-none for comment box with id ${sibling_id}:`, sibling_div)
              sibling_div.classList.remove('d-none');

              /*
                  Show the first child comment for each sibling if it has one
               */
              _self.showFirstChildComment(sibling_id);

              /*
                  Delte the "Load more replies" for siblings we just loaded because their "child" if
                  they have any will already have the button
               */
              // console.log('XXX sibling div',sibling_div)
              // console.log(`REMOVING qip-load-more-comments-text-${sibling_id} !!!`);
              var load_more_button = document.getElementById("qip-load-more-comments-text-".concat(sibling_id));
              if (load_more_button) load_more_button.remove();
            }
          });

          /* Second, unhide children comment */
          var current_comment_id = e.getAttribute('current-comment-id');
          // console.log('current_comment_id:',current_comment_id)

          var current_comment_box = document.getElementById("comment-box-".concat(current_comment_id));
          var children_comment_ids = current_comment_box.getAttribute('children-ids');
          var children_comment_ids_array = children_comment_ids.split(',');
          // console.log('Children comment ids:',children_comment_ids)

          //get child divs and unhide them
          children_comment_ids_array.forEach(function (child_id) {
            var child_div = document.getElementById("comment-box-".concat(child_id));
            if (child_div) {
              // console.log(`removing d-none for comment box with id ${child_id}:`, child_id)
              child_div.classList.remove('d-none');

              /*
                  If the child that has just been unhidden has no children and all its siblings are already
                  unhidden, we need to check if it has a "Load more replies" button and delete it
                  because sometimes we mistakenly load a "load more replies" button where there
                  shouldnt be one
               */
              // console.log('child div id:',child_div)
              /*check if it has children */
              var has_children = child_div.getAttribute('children-ids').length > 0;
              // console.log('does it have children?',has_children)
              //delete load more button if it has one
              if (!has_children) {
                var load_more_button = document.getElementById("qip-load-more-comments-text-".concat(child_id));
                if (load_more_button) {
                  // console.log('load_more_button:',load_more_button);
                  // console.log('id of child',child_id)
                  load_more_button.remove();
                }
              }
            }
          });

          /*
              Remove the "load more comments" link after its been pressed
           */
          e.remove();

          // console.log('xxx more comments for repluies cicked 111')
          /*
              Initialize comment overflow hidden and add action for expand comment button
          */
          _self.intializeCommentOverflow();
        });
      });
    }

    /*
        Shows the first child comment in comment box div for comment id selected
          comment_id: (object), the comment id for which we want to show the first child comment
     */
  }, {
    key: "showFirstChildComment",
    value: function showFirstChildComment(comment_id) {
      // console.log('XXX about to show first child for comment id:',comment_id)

      /*
          Get comment div box and pull the child comments
          Then we will only make the first child comment visible
       */
      var current_comment_box = document.getElementById("comment-box-".concat(comment_id));
      var children_comment_ids = current_comment_box.getAttribute('children-ids');
      var children_comment_ids_array = children_comment_ids.split(',');
      // console.log('Children comment ids:',children_comment_ids)
      //get child divs and unhide them
      var child_div = document.getElementById("comment-box-".concat(children_comment_ids_array[0]));
      if (child_div) {
        // console.log(`removing d-none for comment box with id ${children_comment_ids_array[0]}:`, child_div)
        child_div.classList.remove('d-none');
      }
    }

    /*
     --------------------------------- Load More Comments For Replies For FIRST Comment ---------------------------------
     */

    /*
        Adds action to view more comments for replies
     */
  }, {
    key: "addActionForMoreCommentsForRepliesForFirstComment",
    value: function addActionForMoreCommentsForRepliesForFirstComment() {
      var _self = this;
      console.log('Running addActionForMoreCommentsForRepliesForFirstComment()');

      /*
          Add actions to the "Load More Comments" buttons for comments for first comment
       */
      var more_comments_for_replies_text = document.querySelectorAll('.qip-load-more-comments-text-first-comment');
      more_comments_for_replies_text.forEach(function (e) {
        //add event listener to post button
        e.addEventListener('click', function () {
          // console.log('zzzzzzzzzzzzzzzzzzz qip-load-more-comments-text-first-comment has been clicked!!!')

          /*
              Check if we have initialized this before so we dont initialize it again
              by checking if attribute 'init' is set to true. If not, lets add the attribute 'init' and set it to 'true'.
                If it has been initialized before then return and dont initialize again.
           */
          if (e.getAttribute('init')) return;else {
            e.setAttribute('init', 'true');
          }
          var article_id = e.getAttribute('story-id');
          var parent_comment_id = e.getAttribute('comment-parent-id');
          var current_comment_id = e.getAttribute('current-comment-id');
          // console.log('parent comment id:',parent_comment_id)
          // console.log('current_comment_id:',current_comment_id)

          //grabs author image,name, ajax url, nonce, etc and save it to 'this' object
          _self.setCommentVariables();
          var params = new FormData();
          params.append('action', 'qip_get_more_comments_for_article');
          params.append('number_of_new_ads_to_load', '1'); //only pull the first comment
          params.append('view_more_end_button', "false"); //dont display the "View X More comments" after pull
          params.append('unhide_depth_1_comments', "true"); //unhides all depth=1 comments (ie. all first level replies to comments, but no sub replies)

          //we need to submit both nonces, because logged in and logged out users will get more content
          if (typeof logged_in_nonce !== 'undefined') {
            params.append('logged_in_nonce', logged_in_nonce);
          }
          ;
          //if we dont have a logged_in_nonce set, then set it to blank
          params.append('qip_comments_nonce', qip_comments_nonce);
          params.append('article_id', article_id);

          //do ajax query to password reset
          fetch(ajaxurl, {
            method: 'POST',
            body: params
          }).then(function (res) {
            return res.json();
          })["catch"](function (error) {
            if (window.debugMTS === "1") {
              console.log('error with submission - ', error);
            }
          }).then(function (response) {
            if (window.debugMTS === "1") {
              console.log('response:', response);
            }
            if (response === 0 || !response.status) {
              /*
                  Check if user is logged in and if not then launch a warning
               */
              if (window.debugMTS === "1") {
                console.log('Error: could not get additional comments');
              }
            }

            /*
                If comment was succesfully added
             */
            if (response.status === true) {
              // console.log('response:',response.comments_html);

              //update list of comments to exlclude in "displayed-comment-ids-array" value in parent div to comments
              //so we can exclude them in next pull
              // const string_for_displayed_comment_ids_array = response.next_comments_ids_to_exclude_array_for_next_pull; //make string look like array for js
              // document.getElementById(`commentlist-${article_id}`).setAttribute('displayed-comment-ids-array',string_for_displayed_comment_ids_array);

              /*
                  We need to replace the comment-box with id= comment-box-{comment-id} with this new comment with all the data in it
               */
              var current_comment_div = document.getElementById("comment-box-".concat(current_comment_id));

              //replace first comment with first comment with children comment
              // Create a new element
              var newNode = document.createElement('div');
              newNode.innerHTML = response.comments_html;

              // Get the reference node
              var referenceNode = current_comment_div;

              //rename the `#more-comments-end-text-${article_id}` id so we can delete it after to make way for
              //the updated more-comments-end-text with the updated number of comments left to load
              referenceNode.id = "#comment-box-".concat(article_id, "-old");

              // Insert the new node before the reference node
              referenceNode.parentNode.insertBefore(newNode, referenceNode);

              // Now that we have inserted the new comments and new "more comment" button, we can delete the old "more comments" button
              referenceNode.remove();

              /*
                  Add event listener to "Load More Comments" text for Replies
               */
              _self.addActionForMoreCommentsForReplies();

              /*
                  Add an event listener to detect when user clicks on any REPLY button so we can do an ajax query to
                  add a reply box
               */
              _self.addActionForAllReplyButtons();

              /*
                  Add comment overflow so that long comments are not super long
               */
              _self.intializeCommentOverflow();
            }
          });
        });
      });
    }

    /*
    --------------------------------- Initialize comment vote boxes ---------------------------------
    */
    /*
        This function initializes the comment vote boxes on screen
     */
  }, {
    key: "initializeCommentBoxes",
    value: function initializeCommentBoxes() {
      var comment_boxes = document.querySelectorAll('.comment-box');

      /*
          Initialize every comment box on screen
       */
      comment_boxes.forEach(function (comment_box) {
        /*
            Check if we have initialized this comment box before so we dont initialize it again
            by checking if attribute 'init' is set to true. If not, lets add the attribute 'init' and set it to 'true'.
              If it has been initialized before then return and dont initialize again.
         */
        if (comment_box.getAttribute('init')) return;else {
          // console.log('setting up comment box and setting init to true');
          comment_box.setAttribute('init', 'true');
        }
        var comment_id = comment_box.getAttribute('comment-id');
        // console.log('initializing comment box id:', comment_id);

        var init_comment_vote_box = new QipCommentVoteBox(comment_id);
      });
    }

    /*
    --------------------------------- Edit and Delete Buttons ---------------------------------
    */

    /*
        Add action for all edit/delete buttons
     */
  }, {
    key: "addActionForAllEditAndDeleteCommentButtons",
    value: function addActionForAllEditAndDeleteCommentButtons() {
      var _self = this;

      //find all edit buttons
      var edit_comment_buttons = document.querySelectorAll('.qip_edit_comment_button');

      /*
          Event listener for when user clicks on "edit" button for comment
       */
      edit_comment_buttons.forEach(function (edit_comment_button) {
        /*
            Check if we have initialized this before so we dont initialize it again
            by checking if attribute 'init' is set to true. If not, lets add the attribute 'init' and set it to 'true'.
              If it has been initialized before then return and dont initialize again.
         */
        if (edit_comment_button.getAttribute('init')) return;else {
          edit_comment_button.setAttribute('init', 'true');
        }

        //add event listener to button
        edit_comment_button.addEventListener('click', function (e) {
          console.log('clicked edit button', e);
          var comment_id = edit_comment_button.getAttribute('comment-id');

          /*
              Check that 'edit post' textarea hasnt already been opened. If it has just return
           */
          if (document.getElementById("form-edited-comment-".concat(comment_id))) return;

          /*
              If textarea for 'edit post' is not open yet, then create a new textarea
           */

          //replace text with textarea with comment in it
          var comment_text_div = document.getElementById("qip-comment-text-".concat(comment_id));

          /*
              Before we create edit textarea, lets expand the area if its too long and part
              of it has been hidden due to overflow, so lets click on the overflow button.
              This both expands the text and gets rid of the expand comment button that
              otherwise would be in the comment text itself
           */
          var expand_button = document.getElementById("expand_comment_button_".concat(comment_id));
          if (expand_button) expand_button.click();
          var comment_text = comment_text_div.innerHTML;

          /*
              Replace "<br>" for "/n" so that when we try to edit the comments we dont see <br> in the comment and
              we see actual spaces
           */

          comment_text = comment_text.replace(/<br ?\/?>/ig, "\n");
          console.log('EDITED comment text:', comment_text);

          //hide comment text
          comment_text_div.classList.add('d-none');

          //add textarea with comment text in it
          // const form = _self.replyForm(article_id,parent_comment_id);
          var edit_comment_form = document.createElement("span");
          edit_comment_form.innerHTML = "\n                        <form class=\"qip-comments-form mt-2 mb-3\" id=\"form-edited-comment-".concat(comment_id, "\">\n                            <div class=\"input-group\"> \n                                <textarea class=\"form-control comment-text textarea-autosize\" name=\"comment\" id=\"edited-comment-").concat(comment_id, "\" aria-label=\"With textarea\"  placeholder=\"Edit your comment...\">").concat(comment_text, "</textarea>\n                                <div class=\"input-group-append\">\n                                    <span class=\"input-group-text submit-edit-comment-post-button\" id=\"submit-edit-comment-").concat(comment_id, "\" comment-id=\"").concat(comment_id, "\">Edit</span>\n                                </div>\n                            </div>\n                        </form>\n                ");
          _self.insertAfter(edit_comment_form, comment_text_div);
          // console.log('Edit comment form:',edit_comment_form);

          //add event listener for new added form post button
          _self.addEventListenerForEditCommentsPostButton();

          // Initialize Textarea Autosize
          jQuery('.textarea-autosize').textareaAutoSize();
        });
      });
      var delete_comment_buttons = document.querySelectorAll('.qip_delete_comment_button');
      /*
         Event listener for when user clicks on "edit" button for comment
      */
      delete_comment_buttons.forEach(function (delete_comment_button) {
        /*
            Check if we have initialized this before so we dont initialize it again
            by checking if attribute 'init' is set to true. If not, lets add the attribute 'init' and set it to 'true'.
              If it has been initialized before then return and dont initialize again.
         */
        if (delete_comment_button.getAttribute('init')) return;else {
          delete_comment_button.setAttribute('init', 'true');
        }
        delete_comment_button.addEventListener('click', function (e) {
          /*
              Confirm that user wants to delete comment before we proceed to delete it in a popup
           */
          var r = confirm("Are you sure you want to delete your comment?");
          if (r == true) {
            /*
                If user confirms then delete comment
             */
            var comment_id = delete_comment_button.getAttribute('comment-id');

            // console.log(delete_comment_button);

            //replace text with textarea with comment in it
            var comment_text_div = document.getElementById("qip-comment-text-".concat(comment_id));
            comment_text_div.innerHTML = '<span style="font-style: italic;">This comment has been deleted.</span>';

            //remove kebab icon after deleting comment
            document.getElementById("qip_comments_kebab_menu_".concat(comment_id)).remove();

            //run ajax query to delete the comment
            _self.ajaxQueryDeleteComment(comment_id);
          }
        });
      });
    }

    /*
        Event listener for when user clicks on "post" on the edited comment
        */
  }, {
    key: "addEventListenerForEditCommentsPostButton",
    value: function addEventListenerForEditCommentsPostButton() {
      var _self = this;
      var edit_comment_post_buttons = document.querySelectorAll('.submit-edit-comment-post-button');
      edit_comment_post_buttons.forEach(function (edit_comment_post_button) {
        /*
            Check if we have initialized this before so we dont initialize it again
            by checking if attribute 'init' is set to true. If not, lets add the attribute 'init' and set it to 'true'.
              If it has been initialized before then return and dont initialize again.
         */
        if (edit_comment_post_button.getAttribute('init')) return;else {
          edit_comment_post_button.setAttribute('init', 'true');
        }
        edit_comment_post_button.addEventListener('click', function (e) {
          // console.log('edit_comment_post_button:',edit_comment_post_button);

          var comment_id = edit_comment_post_button.getAttribute('comment-id');

          // console.log('clicked on POST for edit comment - comment id:',comment_id);

          //get new comment text from textarea
          // console.log(`about to hide id: form-edited-comment-${comment_id}`);
          // document.getElementById(`form-edited-comment-${comment_id}`).classList.add('d-none');
          var new_comment_text = document.getElementById("edited-comment-".concat(comment_id)).value;
          // console.log('new comment text:',new_comment_text);

          //replace line breaks "/n" for <br> in order to properly show the user's comments with spaces when displayed
          var new_comment_text_with_line_breaks = new_comment_text.replace(/(?:\r\n|\r|\n)/g, '<br>');

          //update text and unhide comments text
          var comment_text_div = document.getElementById("qip-comment-text-".concat(comment_id));
          comment_text_div.innerHTML = new_comment_text_with_line_breaks;
          comment_text_div.classList.remove('d-none');

          //delete textarea after we dont need it anymore
          document.getElementById("form-edited-comment-".concat(comment_id)).remove();
          _self.ajaxQueryEditComment(comment_id, new_comment_text);
        });
      });
    }

    /*
        Run ajax query to update comment text
     */
  }, {
    key: "ajaxQueryEditComment",
    value: function ajaxQueryEditComment(comment_id, new_comment_text) {
      var _self = this;
      var params = new FormData();
      params.append('action', 'qip_edit_comment_text');
      params.append('logged_in_nonce', logged_in_nonce);
      params.append('comment_id', comment_id);
      params.append('new_comment_text', new_comment_text);

      //do ajax query to password reset
      fetch(ajaxurl, {
        method: 'POST',
        body: params
      }).then(function (res) {
        return res.json();
      })["catch"](function (error) {
        if (window.debugMTS === "1") {
          console.log('error with submission - ', error);
        }
      }).then(function (response) {
        if (window.debugMTS === "1") {
          console.log('response:', response);
        }

        /*
            If comment was succesfully added
         */
        if (response.status === true) {
          // console.log('succesfully got response');
        }
      });
    }

    /*
        Ajax query to delete comment
     */
  }, {
    key: "ajaxQueryDeleteComment",
    value: function ajaxQueryDeleteComment(comment_id) {
      var _self = this;
      var params = new FormData();
      params.append('action', 'qip_delete_comment');
      params.append('logged_in_nonce', logged_in_nonce);
      params.append('comment_id', comment_id);

      //do ajax query to password reset
      fetch(ajaxurl, {
        method: 'POST',
        body: params
      }).then(function (res) {
        return res.json();
      })["catch"](function (error) {
        if (window.debugMTS === "1") {
          console.log('error with submission - ', error);
        }
      }).then(function (response) {
        if (window.debugMTS === "1") {
          console.log('response:', response);
        }

        /*
            If comment was succesfully added
         */
        if (response.status === true) {
          console.log('succesfully got response');
        }
      });
    }

    /*
          Add an overflow hidden to any comments that are too long and initialize expand comment button
       */
  }, {
    key: "intializeCommentOverflow",
    value: function intializeCommentOverflow() {
      // console.log('comment overflow initializing!');

      var _self = this;

      //find all edit buttons
      var all_comments_text = document.querySelectorAll('.qip-comment-text');

      /*
          Event listener for when user clicks on "edit" button for comment
       */
      all_comments_text.forEach(function (comment_text) {
        /*
            Check if we have initialized this before so we dont initialize it again
            by checking if attribute 'init' is set to true. If not, lets add the attribute 'init' and set it to 'true'.
              If it has been initialized before then return and dont initialize again.
              If comment height is zero, it means that its still hidden, so dont initiate yet
         */
        if (comment_text.getAttribute('init') || comment_text.offsetHeight === 0) return;else {
          comment_text.setAttribute('init', 'true');
        }

        // console.log('--------------')
        // console.log('comment total heigh:',comment_text.offsetHeight);
        // console.log('comment scrollHeight:',comment_text.scrollHeight);
        // console.log('comment text:',comment_text);

        /*
            Add 'more' button to expand if comment is too long and overflowing
         */
        var comment_height = comment_text.offsetHeight;
        var comment_total_height = comment_text.scrollHeight;
        var comment_id = comment_text.getAttribute('comment-id');

        // console.log('comment_text',comment_text)

        //detect if comment is being shortened and if so add more button to allow to expand it
        if (comment_total_height > comment_height) {
          // console.log('comment is overflowing!', comment_text);

          //set cursor to pointer
          comment_text.style.cursor = "pointer";

          //add more button on bottom right
          var expand_comment_button = document.createElement('div');
          expand_comment_button.setAttribute("id", "expand_comment_button_".concat(comment_id));
          expand_comment_button.className = 'expand_comment_button';
          // expand_comment_button.innerHTML = `(more)`;
          comment_text.appendChild(expand_comment_button);

          //add event to expand overflowed section on click
          comment_text.addEventListener('click', function (e) {
            //remove pointer cursor
            comment_text.style.cursor = "auto";

            //remove more button
            expand_comment_button.remove();

            //change height of box
            comment_text.style.maxHeight = 'none';
          });
        }
      });
    }
  }]);
}();

/*
    Once dom has been loaded then initialize the qip comments class
 */
document.addEventListener("DOMContentLoaded", function () {
  //initialize class
  console.log('Initializing QIP Comments');
  var comments_obj = new QipComments();
  comments_obj.setEventListeners();
});

/*
--------------------------------- Comment Upvote/downvote ---------------------------------
*/
var QipCommentVoteBox = /*#__PURE__*/function () {
  function QipCommentVoteBox(comment_id) {
    _classCallCheck(this, QipCommentVoteBox);
    this.comment_id = comment_id;
    this.comment_vote_box = document.getElementById("comment-box-".concat(comment_id));
    //when inserting new comments dynamically we dont add up/down arrows so we shouldnt be looking for it
    if (this.comment_vote_box) {
      this.upvote_icon = this.comment_vote_box.getElementsByClassName('comment-upvote-arrow')[0];
      this.downvote_icon = this.comment_vote_box.getElementsByClassName('comment-downvote-arrow')[0];
      this.total_points_num = this.comment_vote_box.getElementsByClassName("comment-vote-score-text")[0];
    }

    // console.log(`Qip comment Votes initialized for comment_id: ${comment_id}
    //
    //         upvote icon: ${this.upvote_icon}
    //         downvote_icon icon: ${this.downvote_icon}
    //         score: ${this.score}
    //
    //
    // `);

    /*
        Set event listeners
     */
    this.setEventListeners();
  }

  /*
       Add event listeners for comment upvotes
   */
  return _createClass(QipCommentVoteBox, [{
    key: "setEventListeners",
    value: function setEventListeners() {
      var _self = this;

      /*
          When clicking the upvote button - 2
       */
      if (this.upvote_icon) {
        this.upvote_icon.addEventListener('click', function (e) {
          // if (!window.qip_is_user_logged_in()) {
          //     window.launchMustBeLoggedIn('You must be logged in to vote. You can log in directly without registering by clicking on the Facebook/Google button below!');
          // } else if (!window.qip_check_is_user_verified()) {
          //     window.qipModalWarning('Sorry, you must verify your email before you can vote. If you have already verified your account please reload the page.')
          // } else {
          //     this.setUpvotedVisuals()
          //     this.ajaxCallVote("up");
          // }
          if (!window.qip_is_user_logged_in()) {
            window.launchMustBeLoggedIn('You must be logged in to vote. You can log in directly without registering by clicking on the Facebook/Google button below!');
          } else {
            /*
                Checks if user is verified
             */
            window.qip_check_is_user_verified(function (is_verified) {
              if (!is_verified) {
                window.qipModalWarning('Sorry, you must verify your email before you can vote.');
              } else {
                _self.setUpvotedVisuals();
                _self.ajaxCallVote("up");
              }
            });
          }
        });
      }

      /*
          When clicking the downvote button
       */
      if (this.downvote_icon) {
        this.downvote_icon.addEventListener('click', function (e) {
          // if (!window.qip_is_user_logged_in()) {
          //     window.launchMustBeLoggedIn('You must be logged in to vote. You can log in directly without registering by clicking on the Facebook/Google button below!');
          // } else if (!window.qip_check_is_user_verified()) {
          //     window.qipModalWarning('Sorry, you must verify your email before you can vote. If you have already verified your account please reload the page.')
          // } else {
          //     this.setDownvotedVisuals();
          //     this.ajaxCallVote("down");
          // }

          if (!window.qip_is_user_logged_in()) {
            window.launchMustBeLoggedIn('You must be logged in to vote. You can log in directly without registering by clicking on the Facebook/Google button below!');
          } else {
            /*
                Checks if user is verified
             */
            window.qip_check_is_user_verified(function (is_verified) {
              if (!is_verified) {
                window.qipModalWarning('Sorry, you must verify your email before you can vote. ');
              } else {
                _self.setDownvotedVisuals();
                _self.ajaxCallVote("down");
              }
            });
          }
        });
      }
    }

    /*
        Sets the visual effects for upvoting by:
            -sets upvoted button to clicked (adds 'voted' class to upvote button)
            -sets downvoted button to unclicked (removes 'voted' class from downvote button)
            -increases the points total by one
            -unclicks button if already selected
       */
  }, {
    key: "setUpvotedVisuals",
    value: function setUpvotedVisuals() {
      var clicked = this.whatVoteButtonIsClicked();

      //if upvote is already clicked, then unclick it and subtract a total point
      if (clicked === "up") {
        this.upvote_icon.classList.remove('voted');
        this.subtractPoint();
      }
      //if upvote button is not yet clicked then set it as clicked and add 1 to total
      else {
        this.upvote_icon.classList.add('voted');
        this.addPoint();

        //if the downvote is clicked then removed "voted" class from it and add one to the total points
        if (clicked === "down") {
          this.downvote_icon.classList.remove('voted');
          this.addPoint();
        }
      }
    }

    /*
        Sets the visual effects for downvoting by:
            -sets downvoted button to clicked (adds 'voted' class to upvote button)
            -sets upvoted button to unclicked (removes 'voted' class from downvote button)
            -decreases the points total by one
            -unclicks button if already selected
           */
  }, {
    key: "setDownvotedVisuals",
    value: function setDownvotedVisuals() {
      var clicked = this.whatVoteButtonIsClicked();

      //check if downvote is already clicked and if so unclick it and add 1 to total points
      if (clicked === "down") {
        this.downvote_icon.classList.remove('voted');
        this.addPoint();
        // this.subtractTotalVote();
      }
      //if its not clicked, then click it and subtract 1 to total points
      else {
        //set upvoted button and add one to the total points
        this.downvote_icon.classList.add('voted');
        this.subtractPoint();

        //if the updated is clicked then remove "voted" class from it and subtract one to the total points
        if (clicked === "up") {
          this.upvote_icon.classList.remove('voted');
          this.subtractPoint();
        }
      }
    }

    /*
        Checks which button has been clicked and returns value:
            -if upvote has been clicked returns "up"
            -up downvote has been clicked returns "down"
            -if none have been clicked returns "none"
          returns: (string), the name of the button that is pre-clicked "up", "down" or "none"
     */
  }, {
    key: "whatVoteButtonIsClicked",
    value: function whatVoteButtonIsClicked() {
      if (this.upvote_icon.classList.contains('voted')) return "up";else if (this.downvote_icon.classList.contains('voted')) return "down";else return "none";
    }

    /*
        Visually add a point to the total score (only visual not in api)
     */
  }, {
    key: "addPoint",
    value: function addPoint() {
      this.total_points_num.innerText = parseInt(this.total_points_num.innerText) + 1;
    }

    /*
        Visually subtract a point to the total score (only visual not in api)
     */
  }, {
    key: "subtractPoint",
    value: function subtractPoint() {
      this.total_points_num.innerText = parseInt(this.total_points_num.innerText) - 1;
    }

    /*
       Ajax call to upvote/downvote on a comment
         article_id: (int), the post id of the article we want to load more comments for
       total_comments_loaded: (int), the total number of comments that have already been loaded for a specific article
      */

    /*
           Ajax call for up and down buttons
        */
  }, {
    key: "ajaxCallVote",
    value: function ajaxCallVote(vote) {
      var _self = this;

      // console.log('in ajax call for vote:',vote)

      var ajaxurl = qip_ajax_url;
      var params = new FormData(); //create url parameter object to send to ajax request

      //set votes variable based on vote
      if (vote === "up") {
        params.append('vote', 'up');
      } else if (vote === "down") {
        params.append('vote', 'down');
      }
      params.append('action', 'qip_comments_vote');
      params.append('logged_in_nonce', logged_in_nonce);
      params.append('comment_id', this.comment_id);

      // console.log(`this.post_id: ${params.get('post-id')}
      // this.logged_in_nonce : ${params.get('mts-upvotes-nonce')}
      // action: ${params.get('action')}
      // `);

      //do ajax query to password reset
      fetch(ajaxurl, {
        method: 'POST',
        body: params
      }).then(function (res) {
        return res.json();
      })["catch"](function (error) {
        if (window.debugMTS === "1") {
          console.log('error with submission - ', error);
        }
      }).then(function (response) {
        //console.log('RESPONSE FROM AJAX:',response)

        if (window.debugMTS === "1") {
          console.log('response:', response);
        }
        if (response === 0 || !response.status) {
          /*
              Check if user is logged in and if not then launch a warning
           */
          if (window.debugMTS === "1") {
            console.log('response.logged_in:', response.logged_in, ', and type is:', _typeof(response.logged_in));
          }
          if (response.logged_in === false) {
            if (window.debugMTS === "1") {
              console.log('1 - must be logged in');
            }
            window.launchMustBeLoggedIn('You must be logged in to vote. You can log in directly without registering by clicking on the Facebook/Google button below!');
          }

          //if user is unverified
          if (response.unverfied_user === true) {
            //remove simulated reply
            var voted_classes = document.querySelectorAll('.voted');
            voted_classes.forEach(function (e) {
              e.classList.remove('voted');
            });
            window.qipModalWarning('Sorry, you must verify your email address before you can vote. If you have already verified your account please reload the page.');
          }
        }
      });
    }
  }]);
}();
/*!
* jQuery Textarea AutoSize plugin : https://github.com/javierjulio/textarea-autosize
* Author: Javier Julio
* Licensed under the MIT license
*/
!function (t, e, i, n) {
  function s(e, i) {
    this.element = e, this.$element = t(e), this.init();
  }
  var h = "textareaAutoSize",
    o = "plugin_" + h,
    r = function r(t) {
      return t.replace(/\s/g, "").length > 0;
    };
  s.prototype = {
    init: function init() {
      var i = parseInt(this.$element.css("paddingBottom")) + parseInt(this.$element.css("paddingTop")) + parseInt(this.$element.css("borderTopWidth")) + parseInt(this.$element.css("borderBottomWidth")) || 0;
      r(this.element.value) && this.$element.height(this.element.scrollHeight - i), this.$element.on("input keyup", function (n) {
        var s = t(e),
          h = s.scrollTop();
        t(this).height(0).height(this.scrollHeight - i), s.scrollTop(h);
      });
    }
  }, t.fn[h] = function (e) {
    return this.each(function () {
      t.data(this, o) || t.data(this, o, new s(this, e));
    }), this;
  };
}(jQuery, window, document);

// Initialize Textarea
$('.textarea-autosize').textareaAutoSize();

},{}]},{},[1]);
